import React from 'react';

import { Icon, Modal, Button } from '@iwoca/orion';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import messages from './ErrorOverlay.messages';
import styles from './ErrorOverlay.module.css';

class ErrorOverlay extends React.Component {
    state = {
        isLoading: false
    };

    componentDidUpdate(prevProps) {
        if (prevProps.time !== this.props.time) {
            const delayId = _.delay(() => {
                this.setState({
                    isLoading: false
                });
                clearTimeout(delayId);
            }, 1500);
        }
    }

    onClick = () => {
        const { retry, action, latestAppState, latestUiState } = this.props;
        this.setState({
            isLoading: true
        });
        const stateToSave = {
            data: {
                application: latestAppState,
                ui: latestUiState
            }
        };
        // if failed action was GET `initial_state` request, then on retry `stateToStave` will be ignored in sagas.
        retry({ type: action, stateToSave });
    };

    render() {
        const { show } = this.props;
        return (
            <Modal
                isOpen={show}
                onClose={() => {}}
                title={this.renderTitle}
                size="medium"
                headerBar>
                <div className={styles.headerContainer}>
                    <Icon
                        icon="exclamationTriangleOutline"
                        aria-hidden="true"
                        className={styles.errorIcon}
                    />
                    <FormattedMessage {...messages.overlayTitle} tagName="h2" />
                </div>
                <hr className={styles.divider} />
                <form>
                    <div>
                        <FormattedMessage
                            {...messages.overlayText}
                            tagName="p"
                        />
                        <Button
                            onClick={this.onClick}
                            disabled={this.state.isLoading}
                            loading={this.state.isLoading}
                            className={styles.errorCTA}>
                            <FormattedMessage
                                {...messages.overlaySubmitButton}
                            />
                        </Button>
                    </div>
                </form>
            </Modal>
        );
    }
}

export default ErrorOverlay;
